export default "__VITE_ASSET__D6w35lE0__"